import { useState } from 'react';
import { shortTrackId } from './shortId.js';

export default function TrackIdBadge({ id, className }: { id: string; className?: string }) {
  const [copied, setCopied] = useState(false);

  function copyId(e: React.MouseEvent) {
    e.stopPropagation();
    navigator.clipboard?.writeText(id);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }

  function copyIdOnKey(e: React.KeyboardEvent) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard?.writeText(id);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }

  return (
    <span
      className={className ? `track-id-badge ${className}` : 'track-id-badge'}
      role="button"
      tabIndex={0}
      onClick={copyId}
      onKeyDown={copyIdOnKey}
      title={id}
      aria-label={`Track ID ${id}. Click to copy full ID.`}
    >
      {copied ? 'Copied' : shortTrackId(id)}
    </span>
  );
}
